import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spacer, useCustomTheme, useWidth } from "common-frontend-components";
import { Hamburger } from "common-frontend-components";
import { FlexSpace } from "common-frontend-components";
import { Appbar } from "common-frontend-components";
import { WwwSidebar } from "../sidebars/WwwSidebar";
import { Box, Grid } from "@mui/material";
import { ContactButton } from "../../entities/contact/ContactButton";
import { CheckoutOurGalleryButton } from "./components/CheckoutOurGalleryButton";
import { SearchButton } from "./components/SearchButton";
import { AboutButton } from "./components/AboutButton";
import { BookButton } from "./components/BookButton";
import { ProductsButton } from "./components/ProductsButton";
import { NewsButton } from "./components/NewsButton";
// import {NavTabs} from "./components/tabs/NavTabs";
export const WwwAppbarWithoutPlaceholderOnDesktop = () => {
    return (_jsx(WwwAppbar, { placeHolder: useWidth() < 645 ? undefined : null }, void 0));
};
export const WwwAppbar = (props) => {
    const theme = useCustomTheme();
    return (_jsx(Box, { sx: { '& header': { top: '0', left: '0', right: 'auto', width: 'calc(100% - 15px)!important' } }, children: _jsx(Appbar
        // toolbarProps={{style:{margin:0, padding: 0}}}
        , { 
            // toolbarProps={{style:{margin:0, padding: 0}}}
            component: ({ color }) => _jsxs(Grid, { container: true, spacing: 2, sx: {
                    paddingBottom: '10px',
                    // width: '100%', height: '100%', backgroundImage: 'linear-gradient(0deg, #273f7288, transparent)'
                }, children: [_jsx(Spacer, { size: theme.spacing(1) }, void 0), _jsxs(Grid, { item: true, children: [_jsx(Hamburger, { color: color }, void 0), _jsx(WwwSidebar, {}, void 0)] }, void 0), _jsx(Box, { sx: { paddingTop: 1, flexGrow: 1, display: { xs: 'none', md: 'flex' } }, children: _jsxs(Grid, { container: true, alignItems: 'center', alignContent: 'center', children: [_jsx(ProductsButton, {}, void 0), _jsx(CheckoutOurGalleryButton, {}, void 0), _jsx(NewsButton, {}, void 0), _jsx(AboutButton, {}, void 0), _jsx(BookButton, {}, void 0)] }, void 0) }, void 0), _jsx(FlexSpace, {}, void 0), _jsx(SearchButton, {}, void 0), _jsx(ContactButton, {}, void 0)] }, void 0), ...props }, void 0) }, void 0));
};
//# sourceMappingURL=WwwAppbar.js.map